import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from '../../../lib/redux/hooks';
import { SpinnerComponent } from "../../../lib/spinner";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { PopupForm } from "../../../ui/organisms/popupForm";
import { removeLegalRepresentative, setRemoveLegalRepresentativeStatus } from "../feature/legalRepresentative/slice";

interface Props {
    visible: boolean;
    onClose: () => void;
    id?: string;
}

export function RemoveLegalRepresentativeModal(props: Props) {
    const { visible, onClose, id } = props;
    const dispatch = useAppDispatch();
    const legalRapresentativeState = useAppSelector(state => state.legalRapresentative);

    useEffect(() => {
        if (legalRapresentativeState.removeLegalRepresentativeStatus === 'successfully') {
            dispatch(setRemoveLegalRepresentativeStatus('idle'));
            onClose();
        }
    }, [legalRapresentativeState.removeLegalRepresentativeStatus, dispatch, onClose]);

    if (!visible) return null;

    const isLoading = legalRapresentativeState.removeLegalRepresentativeStatus === 'loading';

    return (
        <PopupForm title="Rimuovi rappresentante legale" close={onClose}>
            <div className="p-6 bg-white flex flex-col gap-6">
                {
                    isLoading
                        ? <div className="flex justify-center py-2"><SpinnerComponent size={"small"} /></div>
                        :
                        <p className="text-left text-md font-medium text-neutral-700">Sei sicuro di voler rimuovere questo rappresentate legale?</p>
                }
                <div className="flex justify-end gap-2 pt-2 border-t border-neutral-200">
                    <ButtonComponent
                        size="md"
                        iconPosition="off"
                        variant="outline"
                        color="blue"
                        label="Annulla"
                        disabled={isLoading}
                        onClick={onClose}
                    />
                    <ButtonComponent
                        size="md"
                        iconPosition="off"
                        variant="solid"
                        color="red"
                        label="Rimuovi"
                        disabled={isLoading || !id}
                        onClick={() => {
                            if (!id) return;
                            dispatch(removeLegalRepresentative(id));
                        }}
                    />
                </div>
            </div>
        </PopupForm>
    );
}
